import { gql } from "@apollo/client";

export const GQL_PAGINATED_DOSSIER = gql`
   query paginatedDossiers(
      $filters: DossierFilterInput
      $page: Int
      $orderBy: OrderByClause
   ) {
      paginatedDossiers(filters: $filters, page: $page, orderBy: $orderBy) {
         paginatorInfo {
            count
            currentPage
            hasMorePages
            lastPage
            perPage
            total
         }
         data {
            id
            name
            created_at
            lastStatus {
               status
               description
               created_at
            }
            lastMessageMail {
               mode
               type
               date_of_receipt
               created_at
            }
            hasCompleteAssets {
               is_complete
            }
            revenued
            revenued_at
            revenued_number
            comparison
            timeline
            year
            category {
               id
               name
            }
            client {
               id
               company_name
            }
            taxAccount {
               id
               tax_provider {
                  id
                  company_name
               }
            }
         }
      }
   }
`;

export const GQL_DOSSIERS_ALL = gql`
   query dossiers($client_id: ID, $year: Int!, $showAll: Boolean!) {
      dossiers(client_id: $client_id, year: $year) {
         id
         name
         created_at
         lastStatus {
            status
            description
            created_at
         }
         lastMessageMail {
            mode
            type
            date_of_receipt
            created_at
         }
         hasCompleteAssets {
            is_complete
         }
         revenued
         revenued_at
         revenued_number
         comparison
         timeline
         year
         dossierBill {
            bill {
               issue_date
               tax_period_start
            }
         }
         category {
            id
            name
         }
         client @include(if: $showAll) {
            id
            company_name
         }
         taxAccount @include(if: $showAll) {
            id
            tax_provider {
               id
               company_name
            }
         }
      }
   }
`;

export const GQL_DOSSIER = gql`
   query dossier($id: ID!) {
      dossier(id: $id) {
         id
         name
         client {
            id
            company_name
         }
         created_at
         statuses {
            id
            status
            description
            created_at
            user {
               id
               full_name
            }
         }
         lastStatus {
            id
            status
            description
            created_at
            user {
               id
               full_name
            }
         }
         customer_note
         tax_provider_note
         taxAccount {
            id
            code
            address
            place
            zip_code
            comune {
               id
               code
               description
            }
            province {
               id
               description
            }
            tax_provider {
               id
               company_name
               pec
               email
            }
            charityItems {
               charity {
                  id
                  company_name
                  vat_number
                  fiscal_code
                  address
                  place
                  zip_code
                  province {
                     description
                  }
                  comune {
                     description
                  }
               }
               request_info_at
               request_info_recipient
               request_year
            }
            private_tax_providers {
               privateTaxProvider {
                  id
                  company_name
                  vat_number
                  fiscal_code
                  address
                  place
                  zip_code
               }
            }
         }
         dossierBill {
            id
            fixed_amount
            variable_amount
            taxable_amount
            vat_amount
            tax_period_start
            province_additional_amount
            total_amount
            total_amount_forced
            total_amount_calculated
            forced_fields
            rows {
               id
               tax_category_id
               tax_category {
                  id
                  code
                  description
               }
               description #todo
               surface
               annual_coefficient
               fixed_cost
               variable_cost
               province_additional
               fixed_amount
               variable_amount
               taxable_amount
               province_additional_amount
               vat
               vat_amount
               total_amount
               forced_fields
               variations {
                  id
                  description
                  value
                  amount
                  type
                  target
               }
               recycle_variations {
                  id
                  expected_waste
                  real_waste
                  kd
                  surface
                  recycled_waste_percent
                  recycled_waste_weight
                  effective_production_potential
                  target
                  amount
                  province_additional_amount
                  percent
                  total_amount
               }
            }
            additional_rows {
               id
               description
               taxable_amount
               vat
               vat_amount
               province_additional
               province_additional_amount
               total_amount
            }
            emptying_rows {
               id
               description
               bin_capacity
               quantity
               unit
               taxable_amount
               vat
               vat_amount
               province_additional
               province_additional_amount
               total_amount
            }
            perequative_rows {
               id
               bill_perequative_setting_id
               name
               taxable_amount
               vat
               vat_amount
               total_amount
            }
            bill {
               id
               tax_provider {
                  id
                  company_name
                  pec
                  email
               }
               tax_account {
                  id
                  code
                  comune {
                     id
                     code
                     description
                  }
               }
               number
               issue_date
               tax_period_start
               tax_period_end
               fixed_amount
               variable_amount
               taxable_amount
               province_additional_amount
               total_amount
               total_amount_forced
               total_amount_calculated
               forced_fields
               closed
               child_bills {
                  id
                  number
                  issue_date
                  tax_period_start
                  tax_period_end
                  total_amount
               }
               rows {
                  id
                  tax_category_id
                  tax_category {
                     id
                     code
                     description
                  }
                  description #todo
                  surface
                  annual_coefficient
                  fixed_cost
                  variable_cost
                  province_additional
                  fixed_amount
                  variable_amount
                  taxable_amount
                  province_additional_amount
                  vat
                  vat_amount
                  total_amount
                  forced_fields
                  variations {
                     id
                     description
                     value
                     amount
                     type
                     target
                  }
                  recycle_variations {
                     id
                     expected_waste
                     real_waste
                     kd
                     surface
                     recycled_waste_percent
                     recycled_waste_weight
                     effective_production_potential
                     target
                     amount
                     province_additional_amount
                     percent
                     total_amount
                  }
               }
               additional_rows {
                  id
                  description
                  taxable_amount
                  vat
                  vat_amount
                  province_additional
                  province_additional_amount
                  total_amount
               }
               emptying_rows {
                  id
                  description
                  bin_capacity
                  quantity
                  unit
                  taxable_amount
                  vat
                  vat_amount
                  province_additional
                  province_additional_amount
                  total_amount
               }
               perequative_rows {
                  id
                  bill_perequative_setting_id
                  name
                  taxable_amount
                  vat
                  vat_amount
                  total_amount
               }
            }
         }
         assets {
            asset {
               id
               category {
                  id
                  name
               }
               asset_type
               bucket_name
               bucket_key
               file_name
               file_type
               file_size
               description
               auto_generation
            }
         }
         revenued
         invoices {
            id
            type
            issued_at
            number
            asset {
               id
               asset_type
               bucket_name
               bucket_key
               file_name
               file_type
               file_size
            }
         }
         commission {
            commission_type
            percentage
            fixed
         }
         hasCompleteAssets {
            is_complete
            description
         }
         articles {
            article {
               id
            }
         }
         template {
            id
            name
            mail_subject
            mail_body
         }
         timeline
         comparison
         include_adjustment
         include_charities
         include_private_tax_providers
         category {
            id
            name
         }
         default_docs {
            id
            asset_type
            bucket_name
            bucket_key
            file_name
            file_type
            file_size
         }
         taxProviderRequiresModules {
            id
            type
            script_class_name
            sections
         }
         taxProviderModulesAttached {
            tax_provider_module {
               id
               type
            }
            file_name
            file_size
            file_type
            bucket_name
            bucket_key
            manual_upload
            excluded_section_codes
            created_at
            updated_at
         }
         tax_provider_modules_omitted
         invoice {
            id
         }
      }
   }
`;

export const GQL_DOSSIER_REDUCTION_RANKING = gql`
   query dossierReductionsRanking($year: Int!) {
      dossierReductionsRanking(year: $year) {
         taxAccount {
            client {
               id
               company_name
            }
            id
            code
         }
         total
      }
   }
`;

export const GQL_DOSSIER_CUSTOMER_REDUCTION_RANKING = gql`
   query dossierClientReductionsRanking($client_id: ID!) {
      dossierClientReductionsRanking(client_id: $client_id) {
         taxAccount {
            id
            code
            client {
               id
            }
         }
         bill {
            tax_period_start
            tax_period_end
         }
         total
      }
   }
`;

export const GQL_DOSSIER_DOWNLOAD_BILL_DOCUMENT = gql`
   query downloadDossierBillDocument($input: DossierBillDocumentInput!) {
      downloadDossierBillDocument(input: $input) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_DOSSIERS_EXPORT = gql`
   query exportDossiers($client_id: ID, $year: Int) {
      exportDossiers(client_id: $client_id, year: $year) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_DOSSIERS_REVENUE_COUNTER = gql`
   query dossierRevenueCounter($year: Int!) {
      dossierRevenueCounter(year: $year) {
         annual_revenue
         dossiers_accepted
         dossiers_presented
         counter_dossiers_accepted
         counter_dossiers_presented
      }
   }
`;

export const GQL_DOSSIERS_SENDING_LOG = gql`
   query dossierSendingLogs($first: Int, $page: Int, $orderBy: [OrderByClause!]) {
      dossierSendingLogs(first: $first, page: $page, orderBy: $orderBy) {
         paginatorInfo {
            count
         }
         data {
            id
            dossier {
               id
               name
            }
            status
            exception
            mode
            created_at
            environment
            test_recipient
         }
      }
   }
`;

export const GQL_DOSSIERS_BY_IDS = gql`
   query dossiersByIds($ids: [ID]!) {
      dossiersByIds(ids: $ids) {
         id
         name
      }
   }
`;

export const GQL_DOSSIER_MESSAGES = gql`
   query dossierMessages($dossier_id: ID!) {
      dossierMessages(dossier_id: $dossier_id) {
         id
         mode
         type
         user {
            id
            full_name
         }
         sender
         subject
         body
         recipients
         cc
         bcc
         mail_type
         mail_id
         mail_error
         attachments {
            key
            name
            type
         }
         date_of_receipt
         created_at
      }
   }
`;

export const GQL_DOSSIER_MESSAGE_ATTACHMENT_DOWNLOAD = gql`
   query dossierMessagesDownloadAttachment($message_id: ID!, $key: String!) {
      dossierMessagesDownloadAttachment(message_id: $message_id, key: $key) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_DOSSIER_CATEGORIES = gql`
   query dossierCategories($orderBy: [OrderByClause!]) {
      dossierCategories(orderBy: $orderBy) {
         id
         name
         color
      }
   }
`;

export const GQL_DOSSIER_CHARITIES_REPORT_DOWNLOAD = gql`
   query dossierCharitiesDownloadReport($id: ID!) {
      dossierCharitiesDownloadReport(id: $id) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_DOSSIER_PRIVATE_TAX_PROVIDERS_REPORT_DOWNLOAD = gql`
   query dossierPrivateTaxProvidersDownloadReport($id: ID!) {
      dossierPrivateTaxProvidersDownloadReport(id: $id) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_DOSSIER_EMLS = gql`
   query dossierEMLAttachments($dossier_id: ID!) {
      dossierEMLAttachments(dossier_id: $dossier_id) {
         id
         bucket_name
         bucket_key
         file_name
         file_type
         date
         description
         dossier {
            id
         }
      }
   }
`;

export const GQL_DOSSIER_EMLS_DOWNLOAD = gql`
   query dossierEMLAttachmentDownload($dossier_id: ID!, $ids: [ID]!) {
      dossierEMLAttachmentDownload(dossier_id: $dossier_id, ids: $ids) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_DOSSIER_EML_PREVIEW = gql`
   query dossierEMLAttachmentPreview($id: ID!) {
      dossierEMLAttachmentPreview(id: $id) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_DOSSIER_CATEGORIES_AND_MODULES = gql`
   query dossierCategories($orderBy: [OrderByClause!]) {
      dossierCategories(orderBy: $orderBy) {
         id
         name
         color
      }
      taxProviderModules {
         id
         type
         script_class_name
         sections
      }
   }
`;

export const GQL_DOSSIER_EXPORT_STATUSES = gql`
   query exportDossierStatuses($dossier_id: ID!) {
      exportDossierStatuses(dossier_id: $dossier_id) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_ALL_DOSSIERS_FILTERED = gql`
   query dossierAllFiltered($search: String!) {
      dossierAllFiltered(search: $search) {
         id
         name
         taxAccount {
            client {
               company_name
            }
         }
      }
   }
`;
